import React from "react";

import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import { MdEmail } from "react-icons/md";
import { FiPhoneCall } from "react-icons/fi";
import { FaRegFilePdf } from "react-icons/fa";
import { Title, Dot, Text } from "../styles/GlobalStyles";
import Gallery from "./gallery";

export default function Postfestum() {
  const data = useStaticQuery(graphql`
    {
      slika1: file(relativePath: { eq: "DSC_0022.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            height: 800
            quality: 100
            placeholder: BLURRED
            layout: FULL_WIDTH
          )
        }
      }
      slika2: file(relativePath: { eq: "DSC_0034.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            height: 400
            quality: 100
            placeholder: BLURRED
            layout: FULL_WIDTH
          )
        }
      }
      slika3: file(relativePath: { eq: "DSC_0043.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            height: 400
            quality: 100
            placeholder: BLURRED
            layout: FULL_WIDTH
          )
        }
      }
      slika4: file(relativePath: { eq: "DSC_0050.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            height: 400
            quality: 100
            placeholder: BLURRED
            layout: FULL_WIDTH
          )
        }
      }
      slika5: file(relativePath: { eq: "DSC_0052.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            height: 400
            quality: 100
            placeholder: BLURRED
            layout: FULL_WIDTH
          )
        }
      }
      slika6: file(relativePath: { eq: "DSC_0067.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            width: 800
            quality: 100
            placeholder: BLURRED
            layout: CONSTRAINED
          )
        }
      }
      slika7: file(relativePath: { eq: "DSC_0101.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            width: 800
            quality: 100
            placeholder: BLURRED
            layout: CONSTRAINED
          )
        }
      }
      slika8: file(relativePath: { eq: "DSC_0200.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            width: 800
            quality: 100
            placeholder: BLURRED
            layout: CONSTRAINED
          )
        }
      }
    }
  `);

  return (
    <>
      <section className="body-font  bg-teal-50 py-12 text-gray-700">
        <div className="container mx-auto border-b-4 border-teal-500 pb-6">
          <p className="font-inter mb-6 max-w-4xl space-y-6 text-lg font-medium text-gray-700 sm:text-2xl sm:leading-10">
            Dne 8. in 9. junija 2022 je v hotelu Thermana Park Laško potekala
            tradicionalna konferenca 23. Dnevi varstvoslovja. Udeležence so
            nagovorili dekan Fakultete za varnostne vede izr. prof. dr. Andrej
            Sotlar, župan občine Laško g. Franc Zdolšek, rektor Univerze v
            Mariboru prof. dr. Zdravko Kačič ter predsednica
            programsko-organizacijskega odbora konference doc. dr. Maja Modic.
          </p>
          <p className="font-inter mb-6 max-w-4xl space-y-6 text-lg font-medium text-gray-700 sm:text-2xl sm:leading-10">
            V sklopu otvoritve je potekala plenarna okrogla miza z naslovom
            »Nasilje v družini – epidemija, pred katero si prepogosto zatiskamo
            oči, mašimo ušesa in zastiramo usta«. Ob zaključku prvega dne
            konference pa so udeleženci prisluhnili večernemu pogovoru
            predsednice programsko-organizacijskega odbora z ministrico za
            notranje zadeve mag. Tatjano Bobnar. V okviru Dnevov varstvoslovja
            so potekali tudi 4. Slovenski dnevi detektivske dejavnosti in seja
            Programskega sveta Fakultete za varnostne vede.
          </p>
          <p className="font-inter mb-6 max-w-4xl space-y-6 text-lg font-medium text-gray-700 sm:text-2xl sm:leading-10">
            Za naslednje leto si rezervirajte termin 13. in 14. junij 2023. Se
            vidimo v Podčretrtku v Termah Olimia.
          </p>
          <div className="float-none">
            <Gallery />
          </div>
        </div>
      </section>
    </>
  );
}
